import { render, staticRenderFns } from "./EducationTimeline.vue?vue&type=template&id=4d8c0c78&scoped=true&"
import script from "./EducationTimeline.vue?vue&type=script&lang=ts&"
export * from "./EducationTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./EducationTimeline.vue?vue&type=style&index=0&id=4d8c0c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c0c78",
  null
  
)

export default component.exports